import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ExibeMenuService } from './service/shared/exibe-menu.service';
import { StorageService } from './service/shared/storage.service';
import { DialogAcessaCompraComponent } from './shared/components/dialog-acessa-compra/dialog-acessa-compra.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public exibeMenuHamburguer: boolean = false;
  public isMenuAberto: boolean = false;

  constructor(
    private storage: StorageService,
    private router: Router,
    private dialog: MatDialog,
    public menuService: ExibeMenuService,
  ) { }

  ngOnInit(): void {
    this.controlarExibicaoMenuInicial();
  }

  private controlarExibicaoMenuInicial(): void {
    const hasGuid = !!sessionStorage.getItem('guid');
    // Define o estado do menu: false (ocultar) se houver GUID, true (exibir) se não houver.
    this.menuService.toggleMenu(!hasGuid);
  }

  toggleMenu(): void {
    this.isMenuAberto = !this.isMenuAberto;
  }

  public logout() {
    this.storage.clean();
    this.menuService.toggleMenu(true); 
    this.router.navigate(['/']);
  }

  public onAcessaCompras(): void {
    this.dialog.open(DialogAcessaCompraComponent, { width: '450px', disableClose: true});
      // .afterClosed()
      // .subscribe(result => console.log(result));
  }
}
